

























import { Component, Prop, Vue } from 'vue-property-decorator';
import Tab from './Tab.vue';
import BaseComponent from '@/author/components/BaseComponent.vue';
import styles from '@/styles/scss_to_ts.scss';

@Component
export default class Tabs extends BaseComponent {
  @Prop({ default: false }) forceTabsReview?: boolean;
  @Prop({ default: false }) responsive!: boolean;

  tabs: any[] = [];
  focus = 0
  seenTabs: Set<any> = new Set();
  isInteractive :boolean = true;
  isResponsiveAndMobile :boolean = false;  
  renderComponent: boolean = true;

  created() {
    this.tabs = this.$children;
    if (this.forceTabsReview) this.lockForward();
  }

  mounted() {
    window.addEventListener('resize', this.updateIsResponsiveAndMobile);
    if (this.tabs && this.tabs.length > 0) {
      this.tabs = this.tabs.filter((tab)=>tab.$vnode.key!=='mobileAccordion');
      this.activateTab(this.tabs[0]);
      this.tabs.map((tab, index) => tab.setIndex(index));
    }
    this.updateIsResponsiveAndMobile();
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.updateIsResponsiveAndMobile);
  }

  updateIsResponsiveAndMobile(){
    if(!this.responsive) return;
    this.isResponsiveAndMobile = window.innerWidth <= +styles.breakpointPhablet ? true : false;
  }

  handleAccordionToggle(tab: any){
    this.tabs.map(item => item===tab ? this.activateTab(tab) : this.deactivateTab(item));
  }

  focusOnFirst(){
    this.focus = 0;
    this.updateFocus();
  }

  focusOnLast(){
    this.focus = this.tabs.length-1;
    this.updateFocus();
  }

  handleArrow(incr: number){
    this.updatePos(incr);
    this.updateFocus();
  }

  updateFocus(){
    let focusedTab:Tab = this.tabs[this.focus];
    let htmlEl = document.getElementById(focusedTab.parentId);
    if(htmlEl) htmlEl.focus();
  }

  updatePos(incr:number){
    this.focus += incr;
    if(this.focus < 0) this.focus = this.tabs.length-1;
    this.focus %= this.tabs.length;
  }

  open(el: any, clk: any) {
    this.tabs.map(tab =>
      tab._uid === el._uid ? this.activateTab(tab) : this.deactivateTab(tab)
    );
    if (this.complete() && this.forceTabsReview)
      this.unlock();
  }

  complete():boolean{
    return this.seenTabs.size == this.tabs.length;
  }

  activateTab(tab: any) {
    (tab as Tab).setIsActive(true);
    this.seenTabs.add(tab._uid);
  }

  deactivateTab(tab: any) {
    (tab as Tab).setIsActive(false);
  }

  wasTabReviewed(tab: any) {
    return this.seenTabs.has(tab._uid);
  }
}
